import {I18n} from '@aws-amplify/core';
import {AiOutlineCreditCard} from 'react-icons/ai';

import {SimplePageHeader} from '@flexinet/ui-components';
import {ReloadRecordsButton} from '../buttons/ReloadRecordsButton';
import {moduleConfig} from '../config';

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get(moduleConfig.titles.plural)}
            icon={<AiOutlineCreditCard/>}
            // Reload only: payment events are read-only (written by the Stripe webhook),
            // so there is no Add, Edit or Delete to offer.
            tools={[<ReloadRecordsButton key='reload'/>]}
        />
    );
};
